import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSidebarStore = defineStore('sidebar', () => {
    const open = ref(true)

    const toggle = () => {
        open.value = !open.value
    }

    const show = () => {
        open.value = true
    }

    const hide = () => {
        open.value = false
    }

    return { open, toggle, show, hide }
})
